import { createContext, useContext } from "react";

export const AudioInteractionContext = createContext({
  needsInteraction: false,
  ensureAudioReady: async () => true,
  handleUserInteraction: async () => {},
});

export const useAudioInteraction = () => useContext(AudioInteractionContext);
